import { create } from 'zustand';
import {LegendStore} from "../types/legend";

const useLegendStore = create<LegendStore>((set) => ({
  legend: null,
  setLegend: (legend) => set({ legend: legend }),

  showSurfaceMap: true,
  setShowSurfaceMap: (state) => set({ showSurfaceMap: state }),

  showGlobalShapeFile: true,
  setShowGlobalShapeFile: (state) => set({ showGlobalShapeFile: state }),

  showGlobalTextShapeFile: false,
  setShowGlobalTextShapeFile: (state) => set({ showGlobalTextShapeFile: state }),

  showMesh: true,
  setShowMesh: (state) => set({ showMesh: state }),

  visibleUploads: [],
  setVisibleUploads: (uploads) => set({ visibleUploads: uploads }),

  uploadedFeatures: [],
  setUploadedFeatures: (features) => set({ uploadedFeatures: features }),

  uploadingShapefile: false,
  setUploadingShapefile: (state) => set({ uploadingShapefile: state }),

  showDatasetZones: true,
  setShowDatasetZones: (state) => set({ showDatasetZones: state }),

  showLabelLayer: true,
  setShowLabelLayer: (state) => set({ showLabelLayer: state }),

  uploadedShapefile: [],
  setUploadedShapefile: (shapefile) => set({ uploadedShapefile: shapefile }),

  showInSituPoints: false,
  setShowInSituPoints: (state) => set({ showInSituPoints: state }),

  showFWEPoints: false,
  setShowFWEPoints: (state) => set({ showFWEPoints: state }),

  showUploadedShapefile: false,
  setShowUploadedShapefile: (state) => set({ showUploadedShapefile: state }),

  showLayerView: false,
  setShowLayerView: (state) => set({ showLayerView: state }),
}));

export default useLegendStore;
